import { render, staticRenderFns } from "./EventEditDialog.vue?vue&type=template&id=3a2054e2&scoped=true"
import script from "./EventEditDialog.vue?vue&type=script&lang=js"
export * from "./EventEditDialog.vue?vue&type=script&lang=js"
import style0 from "./EventEditDialog.vue?vue&type=style&index=0&id=3a2054e2&prod&lang=scss&scoped=true"
import style1 from "./EventEditDialog.vue?vue&type=style&index=1&id=3a2054e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2054e2",
  null
  
)

export default component.exports